<template>
  <PVInputText
    v-bind="propsAndAttrs"
    v-model="value"
    :pt="passThroughProps"
    unstyled
  />
</template>
<script lang="ts">
export default {
  name: 'StandardInputText',
  compatConfig: { MODE: 3 },
  inheritAttrs: false,
};
</script>

<script setup lang="ts" generic="T extends string">
import { PassThrough } from '@primevue/core';
import type { InputTextPassThroughOptions } from 'primevue/inputtext';
import { computed, useAttrs } from 'vue';

const props = withDefaults(
  defineProps<{
    modelValue: string;
    disabled?: boolean;
    size?: 'sm' | 'md' | 'lg';
    dataTestid?: string;
  }>(),
  {
    size: 'md',
  },
);

const emit = defineEmits<{
  /** Two-way binding for the raw input text. */
  'update:modelValue': [value: string];
}>();

const value = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
});

const sizeClass = computed(() => {
  if (props.size === 'md') return '';

  return `form-control-${props.size}`;
});
const passThroughProps = computed((): PassThrough<InputTextPassThroughOptions> => {
  return {
    root: {
      class: ['form-control', sizeClass.value].join(' '),
    },
  };
});

const attrs = useAttrs();

/**
 * Shut up TypeScript by explicitly typing the result.
 */
const propsAndAttrs = computed(
  () =>
    ({
      ...props,
      ...attrs,
    }) as Record<string, unknown>,
);
</script>
